import { render } from "./QuizTimer.vue?vue&type=template&id=d90c214e&scoped=true"
import script from "./QuizTimer.vue?vue&type=script&lang=js"
export * from "./QuizTimer.vue?vue&type=script&lang=js"

import "./QuizTimer.vue?vue&type=style&index=0&id=d90c214e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d90c214e"]])

export default __exports__